// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box[data-v-7efe9e94]{position:absolute;top:50%;left:calc(100% + 20px);z-index:2;padding:20px;background:#fff;box-shadow:0 3px 20px rgba(0,0,0,.15);transform:translateY(-50%);border-radius:7px}.color[data-v-7efe9e94],.color-picker[data-v-7efe9e94]{border-radius:50%}.color-picker[data-v-7efe9e94]{width:30px;height:30px;cursor:pointer;padding:4px;border:1px solid #d5dae1;position:relative}.color[data-v-7efe9e94]{width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
